import { Component, Input } from '@angular/core';
import { IconV3Component } from '@gea/digital-ui-lib';
import { ApiService } from 'src/app/shared/services/api.service';
import { Document } from 'src/app/shared/data/data.generated';
import { SnackbarV3Service } from '@gea/digital-ui-lib';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'document-actions-renderer',
  template: `
    <span>
      <geaui-icon-v3
        file="16px_download"
        [clickable]="true"
        (click)="downloadDocument(rowData)"
        pTooltip="Download Document"
      ></geaui-icon-v3>
    </span>
  `,
  standalone: true,
  imports: [IconV3Component, TooltipModule],
})
export class RenderActionButton {
  constructor(
    private api: ApiService,
    private snackbar: SnackbarV3Service,
  ) {}
  @Input() rowData: any;
  downloading: boolean = false;

  downloadDocument(doc: Document) {
    this.downloading = true;
    this.snackbar.add({
      severity: 'info',
      summary: 'Download',
      detail: 'Downloading ' + doc.Title,
    });
    this.api.Documents.DownloadDocument(doc, (err: string) => {
      if (err) {
        this.snackbar.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error downloading document: ' + err,
        });
      } else {
        this.snackbar.add({
          severity: 'success',
          summary: 'Download',
          detail: 'Download complete!',
        });
      }
      this.downloading = false;
    });
  }
}
